import { useCreateNewSpace } from '#pplx/frontend/apps/ask/hooks/collections-hooks/useCreateNewSpace.js';
import { useComputerTaskSubmitter } from '#pplx/frontend/apps/ask/hooks/computer-hooks/useComputerTaskSubmitter.js';
import { useSharedSourceSelection } from '#pplx/frontend/apps/ask/hooks/shared-source-selection-hooks/useSharedSourceSelection.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useInputActions } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { useMemo } from 'react';
export const useUpsellActionContentRuntime = ({ firstResult, origin, }) => {
    const { submitComputerTask } = useComputerTaskSubmitter({
        modalOrigin: origin,
        navigateLabel: 'upsell run in computer',
        targetCollection: (firstResult?.collection_info ?? null),
    });
    const { setConfiguredModel } = useThreadConfig();
    const { handleCreateNewSpaceForThread } = useCreateNewSpace();
    const { overwriteSources, sources } = useSharedSourceSelection();
    const { setUserInput } = useInputActions();
    return useMemo(() => ({
        handleCreateNewSpaceForThread,
        overwriteSources,
        setConfiguredModel,
        setUserInput,
        sources,
        submitComputerTask,
    }), [
        handleCreateNewSpaceForThread,
        overwriteSources,
        setConfiguredModel,
        setUserInput,
        sources,
        submitComputerTask,
    ]);
};
//# sourceMappingURL=useUpsellActionContentRuntime.js.map